export default "__VITE_ASSET__Ci563f$q__"